import React, { useState } from "react";

import { BlockStandard } from "components/admin/BlockStandard";
import {
  Button,
  Card,
  CardMedia,
  Checkbox,
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import { WifiQuality } from "api/onboardingTypes";
import { PageStandard } from "components/admin/PageStandard";
import { RoomOutlined, SensorDoorOutlined } from "@mui/icons-material";
import { useUserContext } from "contexts/UserContext";
import { useErrorInfo, useSetError } from "contexts/ErrorContext";
import { CustomCodes } from "contexts/ErrorContextData";
import { createRouter } from "api/wifi";

/* const FRAME_DATA = {
  title: "Buscar melhores soluções",
  h2Subtitle: "Indique a qualidade do wi-fi nos ambientes climatizados",
  explanationBody:
    "Nossas soluções precisam de Wi-Fi para evitar desperdício de energia",
  buttonText: "Continuar",
  nextScreen: "electrical-capacity",
  skipTo: "electrical-capacity",
  imgSrc: "/static/img/solutions/wifi.png",
}; */

const WIFI_DATA: Array<{ value: WifiQuality; text: string }> = [
  {
    value: "great",
    text: "Sinal muito forte e estável",
  },
  {
    value: "good",
    text: "Bom para uso normal, chamadas e automação",
  },
  {
    value: "reasonable",
    text: "Pode haver pequenas quedas ou lentidão",
  },
  {
    value: "bad",
    text: "Conexão instável, risco de desconexões",
  },
  { value: "offline", text: "Não há cobertura Wi-Fi neste ambiente" },
];

const MANUAL_SIGNAL_STRENGHT = "MANUAL_INPUT";

export const WifiQualityManual = ({ history }) => {
  const { currentSpace, currentEnvironment, token } = useUserContext();
  const errorInfo = useErrorInfo();
  const setError = useSetError();
  const [status, setStatus] = useState<WifiQuality>();

  const handleSubmit = async () => {
    if (status && currentSpace?.id && currentEnvironment?.id) {
      try {
        const data = await createRouter(
          token,
          currentSpace.id,
          currentEnvironment.id,
          status,
          MANUAL_SIGNAL_STRENGHT
        );
        console.log("hey", data);
      } catch (error) {
        // @ts-expect-error
        setError(error.response.data.error);
      }
      /* setWifiStatus(status);
      history.push(FRAME_DATA.nextScreen); */
    } else if (!status) {
      setError(CustomCodes.INCOMPLETE_FORM);
    } else {
      setError(CustomCodes.INTERNAL_PWA_ERROR);
    }
  };

  return (
    <PageStandard title="Medindo qualidade do Wi-Fi">
      <BlockStandard hideDivider>
        <Grid item container alignItems="center">
          <RoomOutlined sx={{ mr: 0.5 }} color="secondary" />
          <Typography sx={{ mr: 3 }}>{currentSpace?.schoolName}</Typography>
          <SensorDoorOutlined sx={{ mr: 0.5 }} color="secondary" />
          <Typography sx={{ mr: 3 }}>{currentEnvironment?.name}</Typography>
        </Grid>
      </BlockStandard>

      <BlockStandard hideDivider>
        <Card sx={{ boxShadow: "none" }}>
          <CardMedia
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: 2,
            }}
          >
            <img
              style={{ height: "20vh" }}
              src="/static/img/solutions/wifi.png"
              alt=""
            />
          </CardMedia>
        </Card>
      </BlockStandard>

      <BlockStandard hideDivider>
        <List>
          {WIFI_DATA.map(({ value, text }) => (
            <ListItem
              disablePadding
              key={value}
              sx={{
                border: `1px solid ${
                  !!errorInfo?.code && !status ? "red" : "#595959"
                }`,
                borderRadius: "12px",
                mb: 2,
              }}
            >
              <ListItemButton onClick={() => setStatus(value)}>
                <ListItemIcon>
                  <Checkbox
                    sx={{ color: "#595959" }}
                    color="success"
                    edge="start"
                    checked={status === value}
                  />
                </ListItemIcon>
                <ListItemText primary={text} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </BlockStandard>
      <BlockStandard hideDivider>
        <Button variant="contained" onClick={handleSubmit}>
          Salvar
        </Button>
      </BlockStandard>
    </PageStandard>
  );
};
